import React from 'react';
import AuthService from './AuthService';

export const AuthContext = React.createContext({
  signinRedirectCallback: () => ({}),
  logout: () => ({}),
  signoutRedirectCallback: () => ({}),
  isAuthenticated: () => ({}),
  signinRedirect: (path?: string) => ({}),
  signinSilentCallback: () => ({}),
  createSigninRequest: () => ({}),
  getUser: () => ({})
});

export const AuthConsumer = AuthContext.Consumer;

export const AuthProvider = (props: any) => {
  const authService = new AuthService();

  return (
    // @ts-ignore
    <AuthContext.Provider value={authService}>
      {props.children}
    </AuthContext.Provider>
  );
};
